
import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";

import strings from "core/strings";

import Icon from "ui/atom/Icon";
import Button from "ui/base/Button";
import Page from "ui/Page";

import { useAccount } from "areas/account/fabric";
import Reload from "areas/account/ui/Reload";
import Section from "areas/account/ui/Section";
import Tile from "areas/account/ui/Tile";


export default function Account() {
	const account = useAccount();
	const theme = useTheme();

	const style = {
		body: {
			mt: theme.spacing(2.5),
			gap: theme.spacing(3)
		}
	};

	return (
		<Page maxWidth="md">
			<Page.Header title="Account" subtitle="Manage your account" />
			<Divider flexItem />
			<Page.Body sx={style.body}>
				<Section title="Account Type">
					<Tile.Icon icon="id-card" title="Account Type" description="Personal" />
				</Section>
				<Section title="Add more tokens" indent={2}>
					<Tile.Icon
						icon="coin"
						title="Current Balance"
						description={account.data?.balance ? `${strings.pluralize(account.data?.balance, "token")}` : "No Tokens"}
						action={<Button.Link variant="contained" color="tertiary" size="small" endIcon={<Icon name="chevron-right" size={18} />} to="/pay?redirect_uri=/account">Add Tokens</Button.Link>}
						loading={account.isLoading}
					/>
				</Section>
				<Section title="Automatic reload" indent={2}>
					<Reload
						checked={account.checked}
						data={account.data}
						mutateThreshold={account.mutation.mutateThreshold}
						mutateReload={account.mutation.mutateReload}
						pending={account.mutation.isPending}
						loading={account.isLoading}
						menu={account.menu}
						confirmation={account.confirmation}
					/>
				</Section>
				<Section title="Payments" indent={2}>
					<Tile.Icon icon="credit-card" title="Method" description={account.method.description} loading={account.isLoading} to="methods" />
					<Tile.Icon icon="clock" title="History" description={`${account.data?.history} payments`} loading={account.isLoading} to="deposits" />
				</Section>
			</Page.Body>
		</Page>
	);
}